













import Vue, { PropOptions } from 'vue';
import { mapGetters } from 'vuex';

interface Props {
  isStudioPage: PropOptions;
}

export default Vue.extend({
  name: 'HMModalContainer',
  props: {
    isStudioPage: {
      default: false,
      type: Boolean,
    },
  } as Props,
  computed: {
    ...mapGetters({
      studio: 'studio/currentStudio',
    }),
  },
});
